var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"node-hit-rate-container"},[_c('iframe',{staticClass:"node-hit-rate-iframe",attrs:{"src":_vm.iframeUrl,"frameborder":"0"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }